import { Flowstep } from '@shared/types/flowstep';
import { CancelToken } from '@shared/utils/cancelToken';
import EventEmitter from 'eventemitter3';

interface ExecutionResult {
  warnings?: Error[];
  successRange?: any;
  worksheet?: any;
}

type Events = { started(): void; finished(): void; finished(result: ExecutionResult): void };

abstract class Executor<E extends EventEmitter.ValidEventTypes = Events> {
  abstract flowstep: Flowstep;
  abstract worksheet: any;
  abstract init(flowstep: Flowstep, context: any): void;
  abstract execute(cancelToken?: CancelToken): Promise<ExecutionResult>;
}

export default Executor;
